<div class="log-venda-modal-backdrop" *ngIf="isOpen" (click)="fechar()"></div>

<div class="log-venda-modal" *ngIf="isOpen" role="dialog" aria-modal="true" aria-labelledby="log-venda-modal-title" (click)="$event.stopPropagation()">
  <div class="log-venda-modal__header">
    <div>
      <span class="log-venda-modal__eyebrow">Venda #{{ idVenda }}</span>
      <h3 id="log-venda-modal-title" class="log-venda-modal__title">Log da Venda</h3>
    </div>
    <button type="button" class="log-venda-modal__close" (click)="fechar()" [disabled]="isSaving" aria-label="Fechar">x</button>
  </div>

  <div class="log-venda-modal__body">
    <div class="log-venda-modal__novo">
      <label class="log-venda-modal__label" for="log-venda-mensagem">Novo registro</label>
      <textarea
        id="log-venda-mensagem"
        class="log-venda-modal__textarea"
        rows="3"
        [(ngModel)]="novaMensagem"
        [disabled]="isSaving"
        placeholder="Descreva o evento ocorrido nesta venda...">
      </textarea>
      <div class="log-venda-modal__novo-acoes">
        <button type="button" class="btn btn-primary btn-sm" (click)="registrarLog()" [disabled]="isSaving || !novaMensagem.trim()">
          {{ isSaving ? 'Salvando...' : 'Salvar' }}
        </button>
      </div>
    </div>

    <hr class="log-venda-modal__divider" />

    <div class="log-venda-modal__lista">
      <div class="log-venda-modal__state" *ngIf="isLoadingList">
        <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
        <span>Carregando eventos...</span>
      </div>

      <div class="log-venda-modal__state log-venda-modal__state--error" *ngIf="hasErrorList && !isLoadingList">
        <span>Não foi possível carregar os eventos.</span>
        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="carregarLogs()">Tentar novamente</button>
      </div>

      <div class="log-venda-modal__state" *ngIf="!isLoadingList && !hasErrorList && !logs.length">
        <span>Nenhum evento registrado para esta venda.</span>
      </div>

      <ul class="log-venda-modal__timeline" *ngIf="!isLoadingList && !hasErrorList && logs.length">
        <li class="log-venda-modal__item" *ngFor="let log of logs">
          <div class="log-venda-modal__item-header">
            <span class="log-venda-modal__item-autor">{{ log.nomeCompletoUsuario || log.nomeUsuario }}</span>
            <span class="log-venda-modal__item-data">{{ log.dataRegistro | date:'dd/MM/yyyy HH:mm' }}</span>
          </div>
          <p class="log-venda-modal__item-mensagem">{{ log.mensagem }}</p>
        </li>
      </ul>
    </div>
  </div>
</div>
